<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" origin="top right" offset-y bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="primary" class="mr-n3" outlined small>
        <span class="caption">
          {{ $t('filters.title') }}
        </span>
        <v-icon right small>mdi-filter-outline</v-icon>
      </v-btn>
    </template>
    <v-list class="mw-350 py-3">
      <v-list-item>
        <FilterDates
          :fetchData="fetchHostUserInvoices"
          :label="$t('hausefulInvoices.filters.emissionDate')"
          startDateProp="startDate"
          endDateProp="endDate"
          dateRange
        />
      </v-list-item>
      <v-list-item class="my-2">
        <FilterDates
          :fetchData="fetchHostUserInvoices"
          :label="$t('hausefulInvoices.filters.createDate')"
          startDateProp="creationStartDate"
          endDateProp="creationEndDate"
          filterName="creationDate"
          dateRange
        />
      </v-list-item>
      <v-list-item>
        <v-select
          @change="(status) => applyFilter({ status })"
          :items="status"
          :label="$t('filters.status')"
          hide-details
          clearable
          outlined
          dense
        />
      </v-list-item>
      <!--
      TODO
      Verificar se vamos utilizar esses dois caras aqui em baixo.
      Se sim, dar pedir permissão para que o host possa filtrar por clientes e filiais.

      <v-list-item class="mb-2">
        <v-autocomplete
          v-model="realEstateId"
          @change="(real_estate_id) => applyFilter({ real_estate_id })"
          :search-input.sync="realEstateSearch"
          :loading="realEstateLoading"
          :items="realEstateList"
          :no-data-text="$t('emptyState.noDataDoTheSearch')"
          :label="$t('filters.customers')"
          prepend-inner-icon="mdi-magnify"
          item-value="id"
          item-text="name"
          hide-details
          clearable
          outlined
          dense
        />
      </v-list-item>

      <v-list-item v-show="realEstateId !== null">
        <v-autocomplete
          @change="(branch_id) => applyFilter({ branch_id })"
          :search-input.sync="branchSearch"
          :loading="branchLoading"
          :items="branches"
          :no-data-text="$t('emptyState.noDataDoTheSearch')"
          :label="$t('filters.branches')"
          prepend-inner-icon="mdi-magnify"
          item-value="id"
          item-text="name"
          hide-details
          clearable
          outlined
          dense
        />
      </v-list-item>
      -->
    </v-list>
  </v-menu>
</template>

<script>
import store from '@/store'
import { mapActions, mapMutations, mapGetters } from 'vuex'

import FilterDates from '@/components/filters/FilterDates'

export default {
  name: 'HostInvoicesFilters',

  components: {
    FilterDates,
  },

  computed: {
    ...mapGetters(['branches', 'realEstateList']),
  },

  watch: {
    realEstateSearch(value) {
      if (!value && value?.length <= 2) return

      this.realEstateLoading = true
      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.fetchRealEstatesBySearchText(value).finally(() => this.realEstateLoading = false)
      }, 1000)
    },

    branchSearch(value) {
      if (!value && value?.length <= 2) return

      this.branchLoading = true
      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.fetchBranchBySearchText({
          searchText,
          realEstatesIds: this.realEstateId,
        }).finally(() => this.branchLoading = false)
      }, 1000)
    },
  },

  methods: {
    ...mapMutations(['setFilters']),
    ...mapActions(['fetchHostUserInvoices', 'fetchRealEstatesBySearchText', 'fetchBranchBySearchText']),

    applyFilter(filter) {
      this.setFilters({ ...store.getters.filters, ...filter  })
      this.fetchHostUserInvoices()
    },
  },

  data() {
    return {
      menu: false,
      timer: null,

      realEstateId: null,
      realEstateSearch: null,
      realEstateLoading: false,

      branchId: null,
      branchSearch: null,
      branchLoading: false,

      status: [
        {
          text: this.$t('hausefulInvoices.status.APPROVED'),
          value: 'APPROVED',
        },
        {
          text: this.$t('hausefulInvoices.status.REFUSED'),
          value: 'REFUSED',
        },
        {
          text: this.$t('hausefulInvoices.status.AWAITING_APPROVAL'),
          value: 'AWAITING_APPROVAL',
        },
      ],
    }
  },
}
</script>
